import React from 'react';
import PropTypes from 'prop-types';
import ExcludedClinicians from '../../../containers/Patients/ExcludedClinicians/ExcludedCliniciansContainer';

const PatientNotes = props => <ExcludedClinicians canEditPatients={props.canEditPatients} />;

PatientNotes.propTypes = {
  canEditPatients: PropTypes.bool.isRequired,
};

export default PatientNotes;
